var map = {
	"./403.json": "./locales/pl/403.json",
	"./404.json": "./locales/pl/404.json",
	"./accessSettings.json": "./locales/pl/accessSettings.json",
	"./administration.json": "./locales/pl/administration.json",
	"./advancedQueries.json": "./locales/pl/advancedQueries.json",
	"./advancedRemark.json": "./locales/pl/advancedRemark.json",
	"./audit.json": "./locales/pl/audit.json",
	"./bulk-packaging.json": "./locales/pl/bulk-packaging.json",
	"./buttons.json": "./locales/pl/buttons.json",
	"./calculations.json": "./locales/pl/calculations.json",
	"./calendar.json": "./locales/pl/calendar.json",
	"./cdr.json": "./locales/pl/cdr.json",
	"./clients.json": "./locales/pl/clients.json",
	"./coa.json": "./locales/pl/coa.json",
	"./company-settings.json": "./locales/pl/company-settings.json",
	"./controlCard.json": "./locales/pl/controlCard.json",
	"./costGroups.json": "./locales/pl/costGroups.json",
	"./countries.json": "./locales/pl/countries.json",
	"./csv.json": "./locales/pl/csv.json",
	"./dashboard.json": "./locales/pl/dashboard.json",
	"./datatable.json": "./locales/pl/datatable.json",
	"./demands.json": "./locales/pl/demands.json",
	"./eln.json": "./locales/pl/eln.json",
	"./elnTemplates.json": "./locales/pl/elnTemplates.json",
	"./eqTypes.json": "./locales/pl/eqTypes.json",
	"./equipments.json": "./locales/pl/equipments.json",
	"./errorLogger.json": "./locales/pl/errorLogger.json",
	"./experiments.json": "./locales/pl/experiments.json",
	"./formulations.json": "./locales/pl/formulations.json",
	"./help.json": "./locales/pl/help.json",
	"./integratedSystems.json": "./locales/pl/integratedSystems.json",
	"./integrations.json": "./locales/pl/integrations.json",
	"./inventories.json": "./locales/pl/inventories.json",
	"./kanbanBoard.json": "./locales/pl/kanbanBoard.json",
	"./laboratories.json": "./locales/pl/laboratories.json",
	"./locations.json": "./locales/pl/locations.json",
	"./lookup.json": "./locales/pl/lookup.json",
	"./main.json": "./locales/pl/main.json",
	"./maintTypes.json": "./locales/pl/maintTypes.json",
	"./materialTypes.json": "./locales/pl/materialTypes.json",
	"./materials.json": "./locales/pl/materials.json",
	"./meta-app.json": "./locales/pl/meta-app.json",
	"./metadata.json": "./locales/pl/metadata.json",
	"./methods.json": "./locales/pl/methods.json",
	"./navbar.json": "./locales/pl/navbar.json",
	"./nonconformanceCards.json": "./locales/pl/nonconformanceCards.json",
	"./notifications.json": "./locales/pl/notifications.json",
	"./orders.json": "./locales/pl/orders.json",
	"./password-policies.json": "./locales/pl/password-policies.json",
	"./patients.json": "./locales/pl/patients.json",
	"./permcodes.json": "./locales/pl/permcodes.json",
	"./personel.json": "./locales/pl/personel.json",
	"./pictogram.json": "./locales/pl/pictogram.json",
	"./priceList.json": "./locales/pl/priceList.json",
	"./printers.json": "./locales/pl/printers.json",
	"./processParameters.json": "./locales/pl/processParameters.json",
	"./productTrends.json": "./locales/pl/productTrends.json",
	"./projects.json": "./locales/pl/projects.json",
	"./queryTemplate.json": "./locales/pl/queryTemplate.json",
	"./questionnaire.json": "./locales/pl/questionnaire.json",
	"./reagents.json": "./locales/pl/reagents.json",
	"./reportTemplate.json": "./locales/pl/reportTemplate.json",
	"./reports.json": "./locales/pl/reports.json",
	"./resultQualifier.json": "./locales/pl/resultQualifier.json",
	"./results.json": "./locales/pl/results.json",
	"./sampleWorkflow.json": "./locales/pl/sampleWorkflow.json",
	"./samples.json": "./locales/pl/samples.json",
	"./samplesLogisitics.json": "./locales/pl/samplesLogisitics.json",
	"./samplingList.json": "./locales/pl/samplingList.json",
	"./signin.json": "./locales/pl/signin.json",
	"./signup.json": "./locales/pl/signup.json",
	"./specifications.json": "./locales/pl/specifications.json",
	"./stability-templates.json": "./locales/pl/stability-templates.json",
	"./stabilityTests.json": "./locales/pl/stabilityTests.json",
	"./subcontractors.json": "./locales/pl/subcontractors.json",
	"./superscript.json": "./locales/pl/superscript.json",
	"./suppliers.json": "./locales/pl/suppliers.json",
	"./systemEmail.json": "./locales/pl/systemEmail.json",
	"./tasks.json": "./locales/pl/tasks.json",
	"./testPlans.json": "./locales/pl/testPlans.json",
	"./testReports.json": "./locales/pl/testReports.json",
	"./tests.json": "./locales/pl/tests.json",
	"./traceability.json": "./locales/pl/traceability.json",
	"./trainings.json": "./locales/pl/trainings.json",
	"./transactionSettings.json": "./locales/pl/transactionSettings.json",
	"./transactions.json": "./locales/pl/transactions.json",
	"./translation.json": "./locales/pl/translation.json",
	"./uom.json": "./locales/pl/uom.json",
	"./userManagement.json": "./locales/pl/userManagement.json",
	"./validation.json": "./locales/pl/validation.json",
	"./workflow.json": "./locales/pl/workflow.json"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./locales/pl sync recursive \\.(json)$";